module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "registraion_area",
    staticStyle: {
      "padding-top": "0px",
      "padding-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "registration_box_area reg-box-custom"
  }, [_c('div', {
    staticClass: "registration_box"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "username",
      "type": "text",
      "placeholder": "E-mail cím",
      "autofocus": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group log_dec"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "Jelszó",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "login_buttons"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "connection_btn"
  }, [_c('div', {
    staticClass: "sub_button text-center"
  }, [_c('input', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "value": "Belépés"
    },
    on: {
      "click": _vm.login
    }
  })]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "login_buttons_two"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "username",
      "type": "text",
      "placeholder": "A fentieken kívül add meg a nevedet is",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newsletter),
      expression: "newsletter"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newsletter) ? _vm._i(_vm.newsletter, null) > -1 : (_vm.newsletter)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newsletter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newsletter = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newsletter = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newsletter = $$c
        }
      }
    }
  }), _vm._v("  Kérek rendszeres hírlevelet")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "connection_btn"
  }, [_c('div', {
    staticClass: "sub_button text-center"
  }, [_c('input', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "value": "Regisztráció"
    },
    on: {
      "click": _vm.register
    }
  })])])])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "dialog",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.dialogClicked(false)
      }
    }
  }, [_vm._v("Nem")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.dialogClicked(true)
      }
    }
  }, [_vm._v("Igen")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "dialog2",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n                      Emlékeztető email igényléséhez írd be az alábbi mezőbe az email címedet, amivel regisztráltál. Erre fogsz kapni egy levelet a további teendőkkel.\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forgotEmail),
      expression: "forgotEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "username",
      "type": "email",
      "placeholder": "E-mail cím",
      "autofocus": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.forgotEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.forgotEmail = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Mégsem")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.forgottenPass
    }
  }, [_vm._v("Küld")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "registration_box_all_conts"
  }, [_c('div', {
    staticClass: "registration_logo text-center"
  }, [_c('img', {
    attrs: {
      "src": "images/logo.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "registration_title text-center"
  }, [_c('h6', [_vm._v("Bejelentkezés")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "elfe"
  }, [_c('a', {
    attrs: {
      "data-toggle": "modal",
      "data-target": "#dialog2"
    }
  }, [_vm._v("Elfelejtett jelszó")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "registration_title text-center"
  }, [_c('h6', [_vm._v("Nem vagy még tag?")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Kosarak egyesítése")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n                    A bejelentkezett felhasználód kosarában is találhatók termékek. Szeretnéd azokat is hozzáadni a vásárláshoz?\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Elfelejtett jelszó igénylése")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c351ff2c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/commons/LoginForm.vue
// module id = 127
// module chunks = 0 1 2